<template>
  <div>
    <section
      class="section-title-page container-fluid"
      style="background-image: url('/img/bg_tramite.jpg')"
    >
      <div class="container">
        <div class="wrapper">
          <h1>
            Contáctenos
            <small style="font-weight: 300">para más información</small>
          </h1>
          <span>
            Volver <i class="fa fa-angle-right mx-1"></i>
            <a href="/">Inicio</a>
          </span>
        </div>
      </div>
    </section>
    <section class="section-form pt-4 container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-7">
            <form action="" class="form-contact">
              <div class="d-flex mb-3 border-bottom">
                <p class="text-brown">(*) Todos los campos son obligatorios</p>
              </div>
              <div class="form-group">
                <label for="name" class="required">Nombre y apellidos</label>
                <div class="input-group input-icon">
                  <span class="input-group-text">
                    <i class="fa fa-user" aria-hidden="true"></i>
                  </span>
                  <input
                    type="text"
                    required
                    class="form-control"
                    ref="nombres"
                    placeholder="Ingresar Nombres y Apellidos tal como está en su DNI"
                    id="name"
                    @keypress="isLetter($event)"
                  />
                </div>
                <span
                  v-if="errores.nombres != ''"
                  class="text-danger"
                  role="alert"
                  >{{ errores.nombres }}</span
                >
              </div>
              <div class="d-flex">
                <div class="form-group col-6 pl-0 pr-2 input-icon">
                  <label for="email" class="required">Correo electrónico</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <i class="fa fa-envelope" aria-hidden="true"></i>
                    </span>
                    <input
                      type="email"
                      required
                      ref="correo"
                      class="form-control"
                      @keypress="isMail($event)"
                      placeholder="example@example.com"
                    />
                  </div>
                  <span
                    v-if="errores.correo != ''"
                    class="text-danger"
                    role="alert"
                    >{{ errores.correo }}</span
                  >
                </div>
                <div class="form-group col-6 px-0">
                  <label for="email" class="required">Número de contacto</label>
                  <div class="input-group input-icon">
                    <span class="input-group-text">
                      <i class="fa fa-phone" aria-hidden="true"></i>
                    </span>
                    <input
                      type="text"
                      required
                      maxlength="9"
                      ref="telefono"
                      class="form-control"
                      placeholder="942000000"
                      @keypress="isNumber($event)"
                    />
                  </div>
                  <span
                    v-if="errores.telefono != ''"
                    class="text-danger"
                    role="alert"
                    >{{ errores.telefono }}</span
                  >
                </div>
              </div>
              <div class="form-group">
                <label for="subject" class="required">Asunto</label>
                <input
                  type="text"
                  required
                  ref="asunto"
                  class="form-control"
                  placeholder="Digite el asunto o titulo de su consulta"
                  id="subject"
                />
                <span
                  v-if="errores.asunto != ''"
                  class="text-danger"
                  role="alert"
                  >{{ errores.asunto }}</span
                >
              </div>
              <div class="form-group">
                <label for="message" class="required">Mensaje</label>
                <textarea
                  class="form-control"
                  ref="mensaje"
                  id="message"
                ></textarea>
              </div>
              <div
                class="form-group d-flex justify-content-between align-items-center"
              >
                <button
                  type="button"
                  @click="enviarMail"
                  class="btn bg-brown-opac text-white px-5 font-weight-bold"
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>
          <div class="col-md-5 w-100">
            <iframe
              class="iframe-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3860.9664403869983!2d-76.35863698957635!3d-6.496238293468762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91ba0dcccfd2668d%3A0xc91cf9a74e7c54c5!2sColegio%20M%C3%A9dico%20Veterinario%20de%20San%20Mart%C3%ADn!5e1!3m2!1ses-419!2spe!4v1729704057835!5m2!1ses-419!2spe"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            >
            </iframe>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "contactenos",
  computed: {
    ...mapState(["empresa"]),
  },
  data() {
    return {
      errores: {
        nombres: "",
        telefono: "",
        correo: "",
        mensaje: "",
        asunto: "",
      },
    };
  },
  methods: {
    ...mapMutations(["setLoading"]),
    enviarMail() {
      var self = this;

      if (this.$refs.nombres.value == "") {
        this.$refs.nombres.focus();
        this.errores.nombres = "Campo obligatorio";
        return;
      } else {
        this.errores.nombres = "";
      }

      if (this.$refs.telefono.value == "") {
        this.$refs.telefono.focus();
        this.errores.telefono = "Campo obligatorio";
        return;
      } else if (this.$refs.telefono.value.length < 8) {
        this.$refs.telefono.focus();
        this.errores.telefono = "Requerido 9 dígitos";
        return;
      } else {
        this.errores.telefono = "";
      }

      if (this.$refs.correo.value == "") {
        this.$refs.correo.focus();
        this.errores.correo = "Campo obligatorio";
        return;
      } else if (!this.validEmail(this.$refs.correo.value)) {
        this.$refs.correo.focus();
        this.errores.correo = "Ingrese correo válido";
        return;
      } else {
        this.errores.correo = "";
      }

      if (this.$refs.asunto.value == "") {
        this.$refs.asunto.focus();
        this.errores.asunto = "Campo obligatorio";
        return;
      } else {
        this.errores.asunto = "";
      }

      if (this.$refs.mensaje.value == "") {
        this.$refs.mensaje.focus();
        this.errores.mensaje = "Campo obligatorio";
        return;
      } else {
        this.errores.mensaje = "";
      }

      console.log("enviando ando ando");

      self.setLoading(true);
      let formData = new FormData();
      formData.append("remitente", this.$refs.nombres.value);
      formData.append("telefono_movil", this.$refs.telefono.value);
      formData.append("correo", this.$refs.correo.value);
      formData.append("asunto", this.$refs.asunto.value);
      formData.append("mensaje", this.$refs.mensaje.value);

      this.$http
        .post("ws_main/contact_mail", formData)
        .then((res) => {
          if (res.data.status) {
            this.alertSuccess(res.data.msg, function () {
              location.reload();
            });
          } else {
            this.alertWarning(res.data.msg, function () {
              location.reload();
            });
          }
        })
        .finally(() => {
          this.setLoading(false);
        });
    },
  },
};
</script>